export default __webpack_public_path__ + "static/media/Polyjet.7c984ea7.jpg";